import React,{useEffect, useState} from 'react'
import Carousel from "../../components/Carousel/carousel-component";
import Header from '../../components/Header/header-component';
import Footer from '../../components/Footer/footer-component';
import Pesquisa from '../../components/Pesquisa/pesquisa-component';
import Filtro from '../../components/Filtro/filtro-component';
import Spinner from '../../components/Spinner/spinner-component';
import {store} from '../../../features/store';
import Styles from './home-page.module.scss';
import {useAppSelector, useAppDispatch} from '../../../features/hooks';
import { getConcursos, concursoState} from '../../../features/slices/concurso-slice';
import { ConcursoModel } from '../../../features/Models/concurso-model';
// import {concursoState} from '../../../features/slices/concurso';

const Home:React.FC<any> = () => {

    const [concursos, setConcursos] = useState<Array<ConcursoModel>>();
    let c = useAppSelector(concursoState);

    useEffect(() => {

        store.dispatch(getConcursos());

    }, []);

    // if(c.loading == "succeeded"){
    //     setConcursos(c.concursos);
    // }

    
    return (
        <>
        <div className={Styles.homePage}>
            <Pesquisa />
            <Filtro  />
            {c.loading == "succeeded" ? <Carousel concursos={c.concursos} />:<Spinner loading={true} />}
            </div>
        </>
    )
}

export default Home;
